import { render, staticRenderFns } from "./MFileInput.vue?vue&type=template&id=1134b62a&scoped=true&"
import script from "./MFileInput.vue?vue&type=script&lang=js&"
export * from "./MFileInput.vue?vue&type=script&lang=js&"
import style0 from "./MFileInput.vue?vue&type=style&index=0&id=1134b62a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1134b62a",
  null
  
)

export default component.exports